module.exports = __webpack_public_path__ + "static/media/apps1.bbe8af49.jpg";